import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Home from './components/Home';
import Search from './components/Search';
import Chapter from './components/Chapter';
import Verses from './components/Verses';
import JournalPromptSelected from './components/JournalPromptSelected';

import './assets/landingpage.css';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-37230984-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {
  constructor() {
    super()
    // Dark mode
    let d = document.getElementsByTagName("HTML")[0],
    m = localStorage.getItem("darkmode");
    if(m === "true") {
      d.classList.add("dark-mode");
      window.ReactNativeWebView && window.ReactNativeWebView.postMessage("dark-mode");
    }
  }

  async componentDidMount() {
    // GA event tracking
    document.querySelectorAll('a, button, .features-cards > li, .track-it').forEach(function(elem,index){
      elem.addEventListener('click',function(){
         let myId = elem.id;
         ReactGA.event({
           category: 'Bible',
           action: 'click',
           label: myId
         });
      },false)
   });
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/search" component={Search} />
          <Route path="/c/:chapter" component={Chapter} />
          <Route path="/v/:chapter/:verses" component={Verses} />
          <Route path="/s/:chapter/:verses/:verse" component={JournalPromptSelected} />
        </Switch>
      </Router>
    )
  }
}

export default App;
